import { render, staticRenderFns } from "./CustomEditor.vue?vue&type=template&id=023eb576&"
import script from "./CustomEditor.vue?vue&type=script&lang=js&"
export * from "./CustomEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports